import { PageHero, CTASection } from "@/components/Bits";
import { Reveal } from "@/components/Reveal";
import { PRODUCT_PHOTOS, IMAGES } from "@/lib/data";

export default function Products() {
  return (
    <div>
      <PageHero index="04 — Our Products" title={<>Patterns Built<br />to Perform.</>} subtitle="A selection of industrial patterns manufactured in our workshop." image={IMAGES.cncCoolant} />

      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {PRODUCT_PHOTOS.map((src, i) => {
            const wide = i === 0 || i === PRODUCT_PHOTOS.length - 1;
            return (
              <Reveal key={i} delay={(i % 2) * 0.08}>
                <div className={`group overflow-hidden border border-[#DCE1E8] bg-white ${wide ? "md:col-span-2" : ""}`} data-testid={`product-photo-${i}`}>
                  <img
                    src={src}
                    alt="Industrial pattern"
                    className={`w-full object-cover group-hover:scale-[1.03] transition-transform duration-[900ms] ${wide ? "h-[380px] md:h-[620px]" : "h-[420px] md:h-[560px]"}`}
                  />
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
